import { useCallback, useEffect, useRef, useState } from "react";
import { OTP_COUNTDOWN_SECONDS } from "./gstUtils";

/**
 * Shared 30-second OTP resend countdown timer.
 *
 * Used by both supplier-intelligence and lending/underwriting GST flows.
 * Returns the current countdown value, a `start` callback (resets to 30),
 * and a boolean `isRunning` for convenience.
 */
export function useOtpCountdown() {
  const [countdown, setCountdown] = useState(OTP_COUNTDOWN_SECONDS);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const start = useCallback(() => {
    setCountdown(OTP_COUNTDOWN_SECONDS);
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setCountdown((c) => {
        if (c <= 1) {
          if (timerRef.current) clearInterval(timerRef.current);
          return 0;
        }
        return c - 1;
      });
    }, 1000);
  }, []);

  useEffect(
    () => () => {
      if (timerRef.current) clearInterval(timerRef.current);
    },
    []
  );

  return { countdown, start };
}